import actions from './actions'
import mutations from './mutations'

const accountBalanceHistory = {
    namespaced: true,
    state: {
        accountBalanceHistories: [],
        filters: {
            leader: null,
            business: null,
            fromDate: new Date(+new Date() - 604800000).toISOString().split('T')[0], // current date minus week
            toDate: new Date().toISOString().split('T')[0],
            businesses: []
        },
        isLoaded: false,
        pagination: {
            page: 1,
            length: null,
            total: null
        }
    },
    mutations,
    actions
}

export default accountBalanceHistory
